import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import QueryRequest from '../QueryRequest';

export const GET_ALL_CONTENT_GROUPS = gql`
  query GetContentGroups($projectId: String!, $type: [EContentGroupType]) {
    contentGroup {
      searchContentGroups(
        projectId: $projectId
        status: [UNPUBLISHED, PUBLISHED]
        type: $type
      ) {
        id
        title
        type
        description
        url
        releaseDate
        estimatedTime
        contentType
        iconAsset {
          contentType
          presignedUrl
          s3Key
        }
        status
        sort
        tags {
          id
          name
        }
        groupingContentGroup {
          id
          name
        }
      }
    }
  }
`;

const getContentGroups = ({ projectId, type, onError, onSuccessResult }) => (
  <Query
    fetchPolicy="network-only"
    query={GET_ALL_CONTENT_GROUPS}
    variables={{ projectId, type }}
  >
    {({ loading, error, data }) => (
      <QueryRequest
        data={
          data &&
          Object.entries(data).length !== 0 &&
          data.contentGroup.searchContentGroups
        }
        error={error}
        isLoading={loading}
        onError={onError}
        onSuccessResult={onSuccessResult}
      />
    )}
  </Query>
);

getContentGroups.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  type: PropTypes.string,
};

getContentGroups.defaultProps = {
  type: 'LEARNING',
};

export default getContentGroups;
